export default __webpack_public_path__ + "static/media/cloud-platform.ac018d69.jpg";